package com.wintermar.inspection.feature.presentation.inspection.answer.widget.page_info

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodyRegular
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.feature.domain.model.template.InspectionTemplateModel
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_check
import org.jetbrains.compose.resources.painterResource

@Composable
fun PageInfo(
    currentPage: Int,
    data: InspectionTemplateModel,
    color: ThemeColor = LocalAppTheme.current.color,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    onClick: (pageOrder: Int) -> Unit
) {
    LazyColumn {
        itemsIndexed(data.pages, key = { _, page -> page.id }) { index, page ->
            val totalRequiredQuestion = page.getTotalRequiredQuestions()

            Row(
                modifier = Modifier.fillMaxWidth()
                    .clickable {
                        onClick(page.order)
                    }
                    .padding(
                        vertical = dimension.spacing.space3,
                        horizontal = dimension.spacing.space4
                    ),
                horizontalArrangement = Arrangement.spacedBy(
                    space = dimension.spacing.space2
                )
            ) {
                if (currentPage == page.order) {
                    Icon(
                        painter = painterResource(Res.drawable.ic_check),
                        modifier = Modifier.size(dimension.size.icon.s),
                        tint = color.icon.brand,
                        contentDescription = page.title
                    )
                } else {
                    Spacer(
                        modifier = Modifier.width(dimension.size.icon.s)
                    )
                }

                Column(
                    modifier = Modifier.weight(1f),
                    verticalArrangement = Arrangement.spacedBy(
                        space = dimension.spacing.space3
                    )
                ) {
                    TextBodyRegular(text = page.title)
                    if (totalRequiredQuestion > 0) {
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.spacedBy(
                                space = dimension.spacing.space1
                            ),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            TextBodySmall(
                                text = "${page.getTotalAnsweredRequiredQuestions()} / $totalRequiredQuestion",
                                color = { it.brand },
                                bold = true
                            )
                            TextBodyRegular(
                                text = "required questions answered",
                                color = { it.subtle })
                        }
                    }
                }
            }
            if (index < data.pages.lastIndex) {
                HorizontalDivider(
                    modifier = Modifier.fillMaxWidth(),
                    color = color.border.subtle
                )
            }
        }
    }
}
